<template>
    <common-modal width="extra-huge" @close="emitEvent({ name: 'close' })">
        <common-content-spacer height="medium">
            <common-page-header
                size="medium"
                :heading="$t('pages.company.company_clients.client_reservations', { client: getClientName })"
                :isCenter="true"
            ></common-page-header>
            <div v-if="!isLoading">
                <reservation-list v-if="reservations.length" :reservations="reservations" class="reservations">
                    <common-buttons v-if="reservations.length < totalCount">
                        <common-button
                            type="primary"
                            :label="$t('common.microcopy.show_more')"
                            :isProcessing="isLoading"
                            @click="loadMore"
                        ></common-button>
                    </common-buttons>
                </reservation-list>
                <div v-else>
                    {{ $t('pages.offer.find_offers.no_results') }}
                </div>
            </div>
            <common-loader v-else :isProcessing="isLoading"></common-loader>
        </common-content-spacer>
    </common-modal>
</template>

<script>
    import ReservationList from 'components/page-elements/reservations/ReservationList'
    import CalendarEventAPI from 'api/CalendarEventAPI'
    import ClientsSortFilterEnum from 'enums/clients_sort_filter.enum'

    export default {
        components: { ReservationList },
        props: {
            clientHistoryProp: { type: Object, required: true },
        },

        data() {
            return {
                reservations: [],
                totalCount: 0,
                isLoading: true,
            }
        },

        computed: {
            getClientName() {
                return `${this.clientHistoryProp.firstName} ${this.clientHistoryProp.lastName}`
            },
        },

        methods: {
            loadReservations() {
                this.isLoading = true
                const request = {
                    orderBy: ClientsSortFilterEnum.CREATED_AT_DESC.value.orderBy,
                    wayDefinition: ClientsSortFilterEnum.CREATED_AT_DESC.value.wayDefinition,
                    initiatorId: this.clientHistoryProp.id,
                }
                CalendarEventAPI.getReservationsReceived(request)
                    .then((res) => {
                        this.reservations = res.page
                        this.totalCount = res.total
                    })
                    .finally(() => {
                        this.isLoading = false
                    })
            },
        },

        mounted() {
            this.loadReservations()
        },
    }
</script>

<style lang="scss" sco>
    @import 'styles/setup/_variables.scss';
    @import 'styles/setup/_mixins.scss';

    .reservations {
        @include breakpoint(smartphone-large) {
            max-height: 100%;
        }
        max-height: 500px;
        overflow-y: auto;
    }
</style>
